<p>dialog-admin-study-update works!</p>
